import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCompare } from '../../../hooks/common/useCompare';
import { addLangPrefix } from './Link';

const SHOW_ON = [
    /^\/(ge|ru|en|ua)\/search\/(full\/)?(car|bike|commercial)(\/|$)/,
];

const CompareFab = () => {
    const { t, i18n } = useTranslation();
    const { count } = useCompare();
    const navigate = useNavigate();
    const location = useLocation();

    if (count < 1) return null;
    if (!SHOW_ON.some((re) => re.test(location.pathname))) return null;

    const lang = i18n.language || 'ge';

    return (
        <button
            type="button"
            className="compare-fab"
            onClick={() => navigate(addLangPrefix('/compare', lang))}
            aria-label={t('goToCompare')}
        >
            <span className="compare-fab__label">{t('compare')}</span>
            <span className="compare-fab__count">{count}</span>
        </button>
    );
};

export default CompareFab;
